import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/cms-development/banner_cms.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service on_demand_banner cloud_cost_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={7} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Best CMS Development Company in USA
              </h1>
              <span>Custom CMS for Simplified Content Workflows</span>
              <p style={{ marginTop: "10px" }}>
                Build intuitive, responsive CMS for a consistent and structured
                content lifecycle. From content creation and editing to
                multi-channel distribution, our CMS development services help
                you build a personalized solution with cross-platform
                accessibility and elastic infrastructure.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Build Custom CMS
              </Link>
              <Link to="/projects" className="border_btn web_case_btn">
                Consult CMS Project
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
